import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Col, Row, Container, Form, Card, ListGroup, Image } from 'react-bootstrap'
import { EMPTY_ARRAY, EMPTY_OBJECT, getSvgIcon } from '../../constants/globalConstants'
import debounce from 'lodash/debounce'

// import down from '../../assets/img/download.png'

import { useParams, useNavigate } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import './Extend.scss'
import { getRateDetailsData, getRateHourData, postExtendData } from '../../redux/actions/ExtendFromAction'
import URL from '../../constants/urls'
import Loader from '../../global/Loader'
import { convertTimeToDoubleDig, encryptionHandler, getCardIcon, getConvertedDate, getHoursForRateBand, isPermissionExist, isPromoValidateButton, loggedInUserData, priceGreaterOrNot, sortPortalPermissionByKey, TimeConversion, formatDecimal, isZeroAmount } from '../../utils/helper'
// import MiniHeader from '../../components/global/MiniHeader'
import Footer from '../../components/global/Footer'
import { errorMessage } from '../../constants/errorMessage'
import { endParking, fetchRateBands } from '../../redux/actions/transientAction'
import ConfirmationModal from '../../global/ConfirmationModal'
import UpperHeader from '../../components/global/UpperHeader'
// import ListingDataComp from '../../components/global/ListingDataComp'
import AmountPaid from '../../components/global/AmountPaid'
import ClockTimer from '../../components/global/ClockTimer'
import ExtendEndButton from '../../components/global/ExtendEndButton'
import QRCodeComp from '../../components/global/QRCode'
import NoData from '../../components/NoData'
import DownloadApp from '../../components/global/DownloadApp'
import PaymentBreakUpDetails from '../../components/global/PaymentBreakUpDetails'
import ReactMobiltySpinner from '../../global/ReactMobiltySpinner'
// import { getPartnerDetailsBySLug } from '../../redux/actions/userDetails'
import moment from 'moment-timezone'
import ScrollCalendar from '../scrollCalendar/ScrollCalendar'
import { getCardLists } from '../../redux/actions/PaymentAction'
import PaymentGateDc from '../transientForm/PaymentGatwayDc'
import { useForm } from 'react-hook-form'
// import axios from 'axios'
import PaymentModal from '../../components/global/Payment/PaymentModal'
import CommonListModal from '../../global/CommonListModal'
import { TimeConversionInHours } from '../../../../utils/helper'




function ExtendFormNew(props) {
    const { ticket_id, partner } = useParams()
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors }, control, setFocus } = useForm()
    const { dispatch, notify, isFetchingPartner, partnerDetails, cards } = props

    const [timeDuration, setTimeDuration] = useState({ days: '0', hours: '0', minutes: '0' })

    // const [newtimeDuration, setNewTimeDuration] = useState({ days: '', hours: '', minutes: '' })


    const [gateData, setGateData] = useState(EMPTY_OBJECT)
    const [loader, setLoader] = useState(false)
    const [rateLoader, setRateLoader] = useState(false)
    const [isDisplayDetails, setIsDisplayDetails] = useState(false)
    const [error, setError] = useState('')
    const [totalLength, setTotalLength] = useState(formatDecimal(0))
    const [isTokenApiStarts, setIsTokenApiStarts] = useState(false)
    const [isDisplayRateBand, setIsDisplayRateBand] = useState(false)
    const [rateBandData, setRateBandData] = useState(EMPTY_ARRAY)
    const [rateBands, setRateBands] = useState(EMPTY_ARRAY)
    // const [seletedRateBand, setSelectedRateBand] = useState(EMPTY_ARRAY)
    // const [totalHoursLength, setTotalHoursLength] = useState('0.00')

    // confirmation modal 
    const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false)
    //   
    const [isValidPartner, setIsValidPartner] = useState(true)
    // const [partnerdetails, setPartnerDetails] = useState(EMPTY_OBJECT)
    const [displayBanner, setDisplayBanner] = useState(false)
    const [isScrollCalendarModal, setIsScrollCalendarModal] = useState(false)
    const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))

    // const d2 = moment(new Date().toLocaleString('en-US', { timeZone: facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York' })).format('MM-DD-YYYY hh:mm A')
    const d2 = new Date(getConvertedDate(moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD hh:mm:ss')))
    const [entryDateTime, setEntryDateTime] = useState(d2)
    const [isRateBandSelected, setIsRateBandSelected] = useState(true)
    const [rateBandId, setRateBandId] = useState(null)
    const [selectedRateBand, setSelectedRateBand] = useState(null)
    const local_checkout_datetime = localStorage.getItem('ExtendData')
    const extend_data = JSON.parse(local_checkout_datetime)
    const [selctedDateTime, setselctedDateTime] = useState({
        active: false,
        price: null,
        daysHrs: null,
        dateUntill: null,
        bandActive: false,
    })
    const [loginData, setLoginData] = useState(EMPTY_OBJECT)
    const [currentSelCard, setCurrentCard] = useState(EMPTY_OBJECT)
    // const [currentSelVehicle, setCurrentVehicle] = useState(EMPTY_OBJECT)
    const [cardData, setCardData] = useState(EMPTY_ARRAY)
    const [isCommonModalOpen, setCommonModal] = useState(false)
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
    const [isSubmittingForm, setIsSubmittingForm] = useState(false)
    // const [onSubmitData, setOnSubmitData] = useState(EMPTY_OBJECT)

    const paymentReciept = JSON.parse(localStorage.getItem('paymentRecipt'))

    useEffect(() => {
        const facilityLocHost = JSON.parse(localStorage.getItem('faclityData'))
        const localFacilityID = facilityLocHost?.facility?.id ? facilityLocHost.facility.id : null
        window.scrollTo(0, 0)
        const loginData = loggedInUserData()
        setLoginData(loginData)

        if (loginData?.access_token) {
            if ((cards?.length != cardData?.length) && localFacilityID) {
                dispatch(getCardLists(localFacilityID)).then((res) => {
                    setCardData(res?.data?.payments)
                    setCurrentCard(res?.data?.payments?.[0])
                }).catch((err) => {
                    notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
            }
        }
    }, [EMPTY_ARRAY, cards])

    useEffect(() => {
        setLoader(true)
        // get partner by slug
        if (partner) {
            // dispatch(getPartnerDetailsBySLug(partner)).then((res) => {
            if (partnerDetails?.email) {
                // setPartnerDetails(partnerDetails)
                setIsValidPartner(true)

                const hasAccess = isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Download Banner')
                setDisplayBanner(hasAccess)


                localStorage.removeItem('partnerData')
                sessionStorage.removeItem('partnerData')
                localStorage.setItem('partnerData', JSON.stringify(partnerDetails))
                const partnerData = partnerDetails
                const color = partnerData?.brand_setting?.color
                const rgb = JSON.parse(partnerData?.brand_setting?.rgb_color)
                if (color) {
                    document.documentElement.style.setProperty('--bs-primary', color)
                    document.documentElement.style.setProperty('base-color', color)
                    document.documentElement.style.setProperty('primary', color)
                    document.documentElement.style.setProperty('textcolor', color)
                    document.documentElement.style.setProperty('--bs-btn-bg', color)
                    document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
                    document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
                    document.documentElement.style.setProperty('--bs-list-group-active-color', color)
                    document.documentElement.style.setProperty('--bs-list-group-active-bg', color)

                    if (ticket_id && ticket_id !== undefined) {
                        dispatch(getRateDetailsData(ticket_id)).then((res) => {
                            setLoader(false)
                            if (res?.data) {
                                const data = res?.data
                                data.total = '0.00'
                                data.valid_till = res?.data?.valid_till
                                setGateData(data)
                                // const d2 = moment(new Date(data.checkout_datetime)).format('MM-DD-YYYY hh:mm A')
                                const d2 = new Date(getConvertedDate(moment(new Date(data.checkout_datetime)).format('YYYY-MM-DD hh:mm:ss')))
                                setEntryDateTime(d2)
                                setTotalLength(formatDecimal(0))
                                localStorage.removeItem('ExtendData')
                                localStorage.setItem('ExtendData', JSON.stringify(res?.data))
                                if (res?.data?.facility?.is_price_band == '1') {
                                    // SET RATE BAND TRUE
                                    setIsDisplayRateBand(true)
                                    // FETCH RATE BANDS API DETAILS
                                    const payload = {
                                        'ticket_number': ticket_id ? ticket_id : '',
                                        facility_id: res?.data?.facility?.id,
                                        user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                                    }
                                    dispatch(fetchRateBands(payload)).then((res) => {
                                        if (res?.data) {
                                            // SET RATE BANDS DATA
                                            setRateBandData(res?.data?.price_band)
                                            const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                                            const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                                            const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                                            setRateBands(rateBands)
                                        } else {
                                            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                        }
                                    }).catch((err) => {
                                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                                    })
                                }
                            } else {
                                setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                        }).catch(() => {
                            setError(errorMessage?.somethingWentWrong)
                        })
                    }
                }

            } else {
                if (partnerDetails) {
                    setIsValidPartner(true)
                } else {
                    setIsValidPartner(false)
                }
                localStorage.removeItem('partnerData')
                sessionStorage.removeItem('partnerData')
            }

            // }).catch(() => {

            // })
        }



        // setDaysAmount(EMPTY_OBJECT)


    }, [EMPTY_ARRAY, partnerDetails])




    const handleExtendSubmit = (reservation = false, reservationData, dataPhone) => {
        if (!loader) {
            let extenday = formatDecimal(TimeConversion(timeDuration))
            if (isZeroAmount(extenday) && !isDisplayRateBand) {
                // if (isDisplayRateBand) {
                //     notify('error', 'Please select valid duration')
                // } else {
                notify('error', 'Please select a valid duration')
                // }
            } else {
                setTotalLength(extenday)
                setLoader(true)
                let phone = localStorage.getItem('phone')
                let bandmax_stay = null
                if (isDisplayRateBand && rateBandId) {
                    let max_stay = selectedRateBand.filter((item) => {
                        return item.id == rateBandId
                    })
                    bandmax_stay = max_stay.length > 0 ? max_stay[0] : []
                }
                let postData = {
                    'ticket_number': ticket_id,
                    'extendhours': (isDisplayRateBand && rateBandId) ? bandmax_stay?.max_stay : totalLength ? totalLength : extenday,
                    'rate_band_id': (isDisplayRateBand && rateBandId) ? rateBandId : isDisplayRateBand ? '' : undefined
                }
                if (reservation) {
                    postData.phone = dataPhone ? dataPhone : phone,
                        postData.nonce = loginData?.access_token ? currentSelCard.token : reservationData
                    if (loginData?.access_token) {
                        postData.user_id = loginData?.user?.id
                    }
                }
                dispatch(postExtendData(postData)).then((res) => {
                    setLoader(false)
                    if ((res?.status == 200 || res?.status == 201)) {
                        localStorage.removeItem('ExtendData')
                        localStorage.setItem('ExtendData', JSON.stringify(res?.data))
                        navigate(`/${partner}${URL.EXTENDSUCCESS}`)
                    } else {
                        notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                }).catch((err) => {
                    notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)

                })
            }
        }
    }

    const handleEndParking = () => {
        dispatch(endParking(gateData?.ticket_number)).then((res) => {
            if (res?.status === 201 || res?.status === 200) {
                if (res?.data && res?.data != null) {
                    // notify('success', 'T successfully')
                    // setGateData(res?.data)
                    localStorage.removeItem('paymentRecipt')
                    localStorage.removeItem('ExtendData')
                    notify('success', 'Thank you for parking with us. Please visit us again')

                    setTimeout(() => {
                        const pushBack = JSON.parse(localStorage.getItem('history'))
                        navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
                    }, 3000)
                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                }
            } else {
                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            }
        }).catch(() => {
            notify('error', errorMessage?.somethingWentWrong)
        })
    }

    // const handleDaysChange = (e, name) => {
    //     const { value } = e.target
    //     let data = { ...timeDuration }
    //     if (fieldName === 'Days') {
    //         data['days'] = value
    //         setTimeDuration(data)
    //     } else if (fieldName === 'Hours') {
    //         data['hours'] = value
    //         setTimeDuration(data)
    //     } else if (fieldName === 'Minutes') {
    //         data['minutes'] = value
    //         setTimeDuration(data)
    //     }
    // }    

    const deb = useCallback(
        debounce((e, fromDatePicker) => {
            extendTicket(e, fromDatePicker)
        }, 300),
        [gateData])

    const handleTimeLength = (e) => {
        // e?.preventDefault()
        const { value, name } = e.target
        let data = { ...timeDuration }
        let rateBandSelected
        if (name == 'day') {
            data['days'] = value
            setTimeDuration({ ...timeDuration, days: Number(value) })
        } else if (name == 'hour') {
            data['hours'] = value
            setTimeDuration({ ...timeDuration, hours: Number(value) })
        } else if (name == 'minute') {
            data['minutes'] = value
            setTimeDuration({ ...timeDuration, minutes: Number(value) })
        } else if (name == 'minute-up') {
            data['minutes'] = data.minutes + 15 <= 60 ? Number(data.minutes + 15) : 0
            setTimeDuration(prev => ({ ...timeDuration, minutes: prev.minutes + 15 <= 60 ? Number(prev.minutes + 15) : 0 }))
        } else if (name == 'minute-down') {
            data['minutes'] = data.minutes - 15 >= 0 ? Number(data.minutes - 15) : 60
            setTimeDuration(prev => ({ ...timeDuration, minutes: prev.minutes - 15 >= 0 ? Number(prev.minutes - 15) : 60 }))
        } else if (name == 'hour-up') {
            data['hours'] = data.hours + 1 <= 24 ? Number(data.hours + 1) : 0
            setTimeDuration(prev => ({ ...timeDuration, hours: prev.hours + 1 <= 24 ? Number(prev.hours + 1) : 0 }))
        } else if (name == 'hour-down') {
            data['hours'] = data.hours - 1 >= 0 ? Number(data.hours - 1) : 24
            setTimeDuration(prev => ({ ...timeDuration, hours: prev.hours - 1 >= 0 ? prev.hours - 1 : 24 }))
        } else if (name == 'day-up') {
            data['days'] = data.days + 1 <= 31 ? Number(data.days + 1) : 0
            setTimeDuration(prev => ({ ...timeDuration, days: prev.days + 1 <= 31 ? Number(prev.days + 1) : 0 }))
        } else if (name == 'day-down') {
            data['days'] = data.days - 1 >= 0 ? Number(data.days - 1) : 31
            setTimeDuration(prev => ({ ...timeDuration, days: prev.days - 1 >= 0 ? Number(prev.days - 1) : 31 }))
        } else if ((name && name?.[0]) === 'rateBands') {
            const { value } = e.target
            rateBandSelected = rateBandData?.filter((item) => item?.rate_band_description == value[0])
            setSelectedRateBand(rateBandData)
            setRateBandId(rateBandSelected[0].id)
            // for the rate hour 
            const rateBandHour = getHoursForRateBand(rateBandSelected)
            // setSelectedRateBand(rateBandSelected)
            // to set hours duration
            data['hours'] = Number(rateBandHour)
            let totalHours = '0.00'

            if (rateBandSelected?.[0]?.max_stay) {
                const max_stay_time = rateBandSelected?.[0]?.max_stay?.split('.')
                const minutes = (Number(max_stay_time[1]) / 60)
                totalHours = Number(max_stay_time[0]) + Number(minutes)
            }

            if (totalHours == '0.00') {
                setTotalLength('0')
            }
            // else {
            //     setTotalLength(totalHours)
            // }

            setTimeDuration(data)
            // reset(formValues => ({ ...formValues, 'rate_band_id': seletedRateBand?.[0]?.id }))
            // // FETCH FACILITYRATE
            // const payload = {
            //     promocode: '',
            //     user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
            //     rate_band_id: seletedRateBand?.[0]?.id,
            //     //facility_id: faciltyData?.facility?.id,
            //     // length_of_stay: totalHoursLength,
            //     // 'encrypt': facility,
            // }
            // if (payload?.length !== 0) {
            //     deb(payload, false)
            // }
        }
        // if (name === 'Days') {
        //     data['days'] = value
        //     setTimeDuration(data)
        // } else if (name === 'Hours') {
        //     data['hours'] = value
        //     setTimeDuration(data)
        // } else if (name === 'Minutes') {
        //     data['minutes'] = value
        //     setTimeDuration(data)
        // }
        let extenday = formatDecimal(TimeConversion(data))
        if (!isDisplayRateBand) {


            setTotalLength(extenday)
        }


        if (ticket_id && ticket_id !== undefined) {
            let postData

            if (isDisplayRateBand) {
                postData = {
                    'rate_band_id': rateBandSelected?.[0]?.id ? rateBandSelected?.[0]?.id : '',
                    'length': rateBandSelected?.[0]?.id ? rateBandSelected?.[0]?.max_stay : extenday,
                    'ticket_number': ticket_id,
                    checkoutWithTime: true
                }
            } else {
                postData = {
                    'length': extenday,
                    'ticket_number': ticket_id
                }
            }
            setIsTokenApiStarts(true)

            // HERE
            deb(postData)
        }


    }

    const extendTicket = (postData, fromDatePicker = false) => {
        let checkoutWithTime = false
        if (postData.checkoutWithTime) {
            checkoutWithTime = true
            delete postData.checkoutWithTime
        }
        setRateLoader(true)
        dispatch(getRateHourData(postData)).then((res) => {
            if (res?.data) {
                if (fromDatePicker) {
                    setselctedDateTime({ ...selctedDateTime, bandActive: true, active: true, price: res.data?.parking_amount, dateUntill: res.data?.checkout_time, daysHrs: getHoursIndate(postData.length) })
                }
                setRateLoader(false)
                setIsTokenApiStarts(false)
                const data = { ...gateData, ...res?.data }
                // data.total = res?.data?.rate
                // data.valid_till = res?.data?.valid_till
                // data.discount_amount = 0
                setGateData(data)
                // const d2 = moment(new Date(data.checkout_datetime)).format('YYYY-MM-DD hh:mm A')
                // setEntryDateTime(d2)
                if (checkoutWithTime) {
                    const currentTime = new Date(getConvertedDate(moment(new Date(res?.data?.current_time)).format('YYYY-MM-DD HH:mm:ss')))
                    const checkoutTime = new Date(getConvertedDate(moment(new Date(res?.data?.checkout_time)).format('YYYY-MM-DD HH:mm:ss')))
                    const totalHours = moment(checkoutTime).diff(currentTime, 'minutes')
                    const duration = TimeConversionInHours(res?.data?.length)
                    setTotalLength(formatDecimal(duration))
                    console.log(totalHours)
                    // setTotalHoursLength(formatDecimal(duration))meRemain)
                }
            } else {
                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                setIsTokenApiStarts(false)
                setRateLoader(false)
                setTotalLength('0')
                setIsRateBandSelected(false)
                setRateBandId(null)
                setTimeDuration({ days: '0', hours: '0', minutes: '0' })
            }

        }).catch((err) => {
            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            setIsTokenApiStarts(false)
            setRateLoader(false)
            setTotalLength('0')
            setIsRateBandSelected(false)
            setRateBandId(null)
            setTimeDuration({ days: '0', hours: '0', minutes: '0' })
        })
    }


    // modal confirmation

    const handleConfimationModal = () => {
        setIsConfimationModalOpen(!isConfimationModalOpen)
    }

    const openDateCalendar = () => {
        setIsScrollCalendarModal(true)
    }

    const handleEntryTime = (event) => {
        setIsRateBandSelected(false)
        localStorage.removeItem('seletedRateBand')
        // setEntryDateTime(event)
        // setValue('entry_time',event)       
        // let currentTime = exitDateTime
        // const currentTime = moment(new Date(local_checkout_datetime?.checkout_datetime ? local_checkout_datetime.checkout_datetime : gateData.checkout_datetime)).format('MM-DD-YYYY hh:mm A')
        // const currentTime = moment(new Date(getConvertedDate(moment(new Date(local_checkout_datetime?.checkout_datetime ? local_checkout_datetime.checkout_datetime : gateData.checkout_datetime)).format('YYYY-MM-DD HH:mm:ss')))).format('YYYY-MM-DD HH:mm:ss')
        const localDT = local_checkout_datetime?.checkout_datetime ? local_checkout_datetime.checkout_datetime : gateData.checkout_datetime
        const inputDate = moment.tz(localDT, facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York')
        const newYorkDate = inputDate.clone().tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York')
        const currentTime = new Date(getConvertedDate(moment(newYorkDate).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))

        let pickTime = event
        let hours = diff_hours(pickTime, currentTime)
        setTotalLength(hours)
        let daysUpd = Math.floor(hours / 24)
        let hoursUpd = formatDecimal(Number(hours % 24)).split('.')[0]
        let minutesUpd = formatDecimal(Number(hours % 24)).split('.')[1]
        setTimeDuration({ ...timeDuration, days: Number(daysUpd), hours: Number(hoursUpd), minutes: Number(minutesUpd) })
        const postData = {
            'length': hours,
            'ticket_number': ticket_id,
            'rate_band_id': isDisplayRateBand ? '' : undefined
        }
        if (postData?.length !== 0) {
            deb(postData, true)
        }
    }

    const diff_hours = (endTime, startTime) => {
        // const startDate = new Date(startTime)
        // const endDate = new Date(endTime)
        // let timeDiff
        // if (!isNaN(startDate) && !isNaN(endDate)) {
        //     const timeDifferenceInMilliseconds = endDate - startDate
        //     const hours = Math.floor(timeDifferenceInMilliseconds / 3600000)
        //     const minutes = Math.floor(
        //         (timeDifferenceInMilliseconds % 3600000) / 60000
        //     )
        //     timeDiff = `${hours}.${minutes < 10 ? '0' + minutes : minutes}`
        // } else {
        //     timeDiff = 'Invalid Time'
        // }
        let start = new Date(getConvertedDate(moment(startTime)?.format('YYYY-MM-DD HH:mm'))).getTime()
        let end = new Date(getConvertedDate(moment(endTime)?.format('YYYY-MM-DD HH:mm'))).getTime()
        var diff = moment(end).diff(start, 'minutes')
        let timeDiff
        if (!isNaN(start) && !isNaN(end)) {
            var hours = Math.floor(diff / 60)
            var minutes = Math.floor(diff % 60)
            timeDiff = `${hours}.${minutes < 10 ? '0' + minutes : minutes}`
            timeDiff = formatDecimal(timeDiff)
        } else {
            timeDiff = 'Invalid Time'
        }
        return timeDiff
    }
    const getHoursIndate = (hours) => {
        if (Number(hours) > 0) {
            const day = Math.floor(Number(hours) / 24)
            if (isZeroAmount(Number(hours) % 24)) {
                return `${day} ${day === 1 ? 'Day' : 'days'}`
            }
            return (Number(hours) < 1) ? convertTimeToDoubleDig(hours) + ' MM' : (Number(hours) === 1) ? convertTimeToDoubleDig(hours) + ' HR' : convertTimeToDoubleDig(hours) + ' HRS'
        }
    }
    const getDateFormatToshow = (dt) => {
        return moment(dt).format('MMM DD, YYYY hh:mm A')
    }

    const handleValidateTicket = (paymentData) => {
        if (paymentData?.paid_date) {
            notify('error', 'This ticket is already validated.')
        } else {
            // navigate(`/${partner}${URL?.SCAN_VALIDATE}`)
            navigate(`/${partner}${URL?.SCAN_VALIDATE}`, { state: { redirectUrl: `/${partner}${URL?.EXTEND_URL}/${ticket_id}` } })
        }
    }

    const handleCommonListModal = () => {
        if (cardData?.length > 0) {
            setCommonModal(!isCommonModalOpen)
        } else {
            handlePaymentModal()
        }
    }

    const handlePaymentModal = () => { setIsPaymentModalOpen(!isPaymentModalOpen) }

    const onSubmit = (data) => {
        if (!loader) {
            let extenday = formatDecimal(TimeConversion(timeDuration))
            if (isZeroAmount(extenday) && !isDisplayRateBand) {
                // if (isDisplayRateBand) {
                //     notify('error', 'Please select valid duration')
                // } else {
                notify('error', 'Please select a valid duration')
                // }
            } else {
                setIsSubmittingForm(true)
                if (!isSubmittingForm) {
                    // setOnSubmitData(data)
                    handleSubmitAction(data)
                }
            }
        }
    }

    const handleSubmitAction = (data) => {
        if (loginData?.access_token) {
            handleExtendSubmit(true)
        } else {
            // const payload = {
            //     'Account': data?.card_number ? data?.card_number : '',
            //     'ExpirationMonth': data?.expiry ? data?.expiry.substr(0, 2) : '',
            //     'ExpirationYear': data?.expiry ? `20${data?.expiry.substr(2, 5)}` : '',
            //     'CVV': data?.cvv ? data?.cvv : ''
            // }
            // const headers = { 'Authorization': facilityLocData?.DATACAP_TOKEN, 'Content-Type': 'application/json', Accept: 'application/json' }
            // axios.post(facilityLocData?.DATACAP_OTU_URL, payload, { headers })
            // .then((response) => {
            //     if (response?.data) {
            //         handleExtendSubmit(true, response?.data, data.phone)
            //     } else if (response?.Error) {
            //         setIsSubmittingForm(false)
            //         notify('error', response?.data ? response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
            //     }
            // }).catch((err) => {
            //     setIsSubmittingForm(false)
            //     notify('error', err?.response?.data ? err?.response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
            // })
            const card = {
                name_on_card: data?.name_on_card,
                card_number: data?.card_number,
                expiration_date: data?.expiry,
                security_code: data?.cvv,
                zip_code: ''
            }
            const nonce = encryptionHandler(card)
            handleExtendSubmit(true, nonce, data.phone)
        }
    }


    const returnClockTimer = () => {
        return (
            <ClockTimer
                screen={'extend'}
                facilityData={gateData}
                isExpire
            />
        )
    }

    const retunnValidateTicket = () => {
        if (isPromoValidateButton(gateData, ['2', '3']) && (!gateData.reservation_id || !gateData.reservation_id === null) && (!gateData.paid_date)) {
            return (
                <div className='col-sm-6'>
                    <button
                        type="button"
                        className='text-decoration-none border-btn border bg-white text-primary border-primary rounded text-center w-100 ps-4 pe-4 pt-2 pb-2'
                        onClick={() => handleValidateTicket(gateData)}
                    >
                        Validate Ticket
                    </button>
                </div>
            )
        } else {
            return ''
        }

    }

    const handleCurrentSelection = (item) => {
        setCurrentCard(item)
    }

    return (
        isFetchingPartner ? null : <div className={'Pave main'}>
            {/* <MiniHeader isDisplayBack={true} title={'EXTEND STAY'} partnerdetails={partnerdetails} /> */}
            {error ? <NoData message={error} /> :
                (isValidPartner) ?
                    (loader && gateData == EMPTY_OBJECT) ?
                        <div className='d-flex align-items-center justify-content-center'><Loader /></div> :
                        gateData != EMPTY_OBJECT ? (
                            <>
                                <UpperHeader faciltyData={gateData} totalHoursLength={totalLength ? totalLength?.toString() : formatDecimal(0)} isDirection screen='Extend New' reservationData={gateData} />

                                <Container className='border-bottom'>
                                    <Row className='m-0 p-0'>
                                        <Form onSubmit={(e) => e.preventDefault()}>
                                            <Row>
                                                <Col className='p-3'>
                                                    <Form.Group className="mb-3" controlId="formBasicPassword">

                                                        <Row>
                                                            {/* {gateData?.facility?.is_multiday_parking != 0 && <Col className='border border-2 border-primary rounded me-4'>
                                                            <center><FormLabel className='fw-normal small'>Days</FormLabel></center>
                                                            <Col className='d-flex'>
                                                                <input className='p-2 w-75 border-0 text-end pe-4' type='text' key={timeDuration?.days} defaultValue={timeDuration?.days} autoFocus={true} onKeyPress={(event) => { if (!/[0-9/.]/.test(event.key) || timeDuration?.days + event.key > 31) event.preventDefault() }} maxLength={2} onChange={(e) => { handleTimeLength(e, 'day') }} placeholder='' />
                                                                <Row className='ms-1 mt-1 text-end mb-2'>
                                                                    <i className="fa fa-caret-up text-info" onClick={(e) => { handleTimeLength(e, 'day-up') }} aria-hidden="true"></i>
                                                                    <i className="fa fa-caret-down text-info" onClick={(e) => { handleTimeLength(e, 'day-down') }} aria-hidden="true"></i>
                                                                </Row>
                                                            </Col> */}
                                                            {/* {/ <Form.Control className='text-center border-0' type='number' min='0' max='31' defaultValue={0} name='Days' onChange={(e) => handleTimeLength(e, 'Days')} / > /} */}
                                                            {/* <select className="form-select selectPalceholdr" size="02" name='Days' aria-label="Default select example" onChange={(e) => handleTimeLength(e, 'Days')}>
                                                                            {dayData?.map((item, itemIndex) => <option key={itemIndex} value={item?.val}>{item?.no_of_days}</option>)}
                                                                        </select> */}
                                                            {/* </Col>}
                                                        <Col className='border-info border border-2 rounded me-4'>
                                                            <center><FormLabel className='fw-normal small'>Hours</FormLabel></center>
                                                            <Col className='d-flex'>
                                                                <input className='p-2 w-75 border-0 text-end pe-4' type='text' key={timeDuration?.hours} defaultValue={timeDuration?.hours} autoFocus={true} onKeyPress={(event) => { if (!/[0-9/.]/.test(event.key) || timeDuration?.hours + event.key > 24) event.preventDefault() }} maxLength={2} onChange={(e) => { handleTimeLength(e, 'hour') }} placeholder='' />
                                                                <Row className='ms-1 mt-1 text-end mb-2'>
                                                                    <i className="fa fa-caret-up text-info" onClick={(e) => { handleTimeLength(e, 'hour-up') }} aria-hidden="true"></i>
                                                                    <i className="fa fa-caret-down text-info" onClick={(e) => { handleTimeLength(e, 'hour-down') }} aria-hidden="true"></i>
                                                                </Row>
                                                            </Col> */}
                                                            {/* {/ <Form.Control className='text-center border-0' type='number' min='0' max='24' defaultValue={0} name='hours' onChange={(e) => handleTimeLength(e, 'Hours')} / > /} */}
                                                            {/* <select className="form-select selectPalceholdr" size="02" name='Hours' placeholder="Hours" aria-label="Default select example" onChange={(e) => handleTimeLength(e, 'Hours')} >
                                                                             {hoursData?.map((item, itemIndex) => <option key={itemIndex} selected={item?.val == 2} value={item?.val}>{item?.no_of_hours}</option>)}
                                                                        </select> */}
                                                            {/* </Col>
                                                        <Col className='border border-info border-2 rounded'>
                                                            <center><FormLabel className='fw-normal small'>Minutes</FormLabel></center>
                                                            <Col className='d-flex'>
                                                                <input className='p-2 w-75 border-0  text-end pe-4' type='text' key={timeDuration?.minutes} defaultValue={timeDuration?.minutes} autoFocus={true} onKeyPress={(event) => { if (!/[0-9/.]/.test(event.key) || timeDuration?.minutes + event.key > 60 || (timeDuration?.minutes + event.key.length > 1 && (timeDuration?.minutes + event.key) % 15 !== 0)) event.preventDefault() }} maxLength={2} onChange={(e) => { handleTimeLength(e, 'minute') }} placeholder='' />
                                                                <Row className='ms-1 mt-1 text-end mb-2'>
                                                                    <i className="fa fa-caret-up text-info" onClick={(e) => { handleTimeLength(e, 'minute-up') }} aria-hidden="true"></i>
                                                                    <i className="fa fa-caret-down text-info" onClick={(e) => { handleTimeLength(e, 'minute-down') }} aria-hidden="true"></i>
                                                                </Row>
                                                            </Col> */}
                                                            {/* {/ <Form.Control className='text-center border-0' type='number' min='0' max='60' defaultValue={0} step={15} name='Minutes' onChange={(e) => handleTimeLength(e, 'Minutes')} / > /} */}
                                                            {/* <select className="form-select selectPalceholdr" size="02" name='Minutes' placeholder="Minutes" aria-label="Default select example" onChange={(e) => handleTimeLength(e, 'Minutes')} >
                                                                            {minutesData?.map((item, itemIndex) => <option key={itemIndex} value={item?.val}>{item?.no_of_minutes}</option>)}
                                                                        </select> */}
                                                            {/* </Col> */}
                                                            {isDisplayRateBand ? <div>
                                                                {rateBands?.rateBands?.length > 0 && <>
                                                                    <Form.Label className='text-primary mb-0 pb-0 styleLables'>Rate Band <span className='text-danger'>*</span></Form.Label>
                                                                    <ReactMobiltySpinner
                                                                        handleTimeLength={(e) => handleTimeLength(e)}
                                                                        // currRateBand={timeDuration?.minutes}
                                                                        isRateBand
                                                                        isRateBandSelected={isRateBandSelected}
                                                                        rateBands={rateBands}
                                                                        setIsRateBandSelected={setIsRateBandSelected}
                                                                        setselctedDateTime={setselctedDateTime}
                                                                        selctedDateTime={selctedDateTime}
                                                                        rateBandData={rateBandData}
                                                                    />
                                                                </>}
                                                                <div className='p-0 m-0 d-flex justify-content-center align-items-center row'>
                                                                    <div className={`${selctedDateTime.bandActive ? 'border-primary' : 'border-grey'} border border-2 rounded m-2 pb-2 pt-2`} onClick={openDateCalendar}>
                                                                        <div className='pb-1 pt-1 d-flex justify-content-between align-items-center'>
                                                                            <div className='lh-sm'>{(selctedDateTime.active) ? selctedDateTime.daysHrs : 'Custom Date & Time'}<div className='sub-label small text-muted'><small>{(selctedDateTime.active) ? 'Until ' + getDateFormatToshow(selctedDateTime.dateUntill) : 'Select Date & Time'}</small></div></div>
                                                                            <span>{(selctedDateTime.active) ? '$' + formatDecimal(selctedDateTime.price) : '--'}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* <div className='mt-3 mb-3'>
                                                                        <Form.Label className='text-primary  styleLables'>Pick Date & Time</Form.Label>
                                                                        <button className='form-control text-left' onClick={openDateCalendar}>{entryDateTime}</button>
                                                                    </div> */}
                                                            </div> :

                                                                <ReactMobiltySpinner
                                                                    handleTimeLength={(e) => handleTimeLength(e)}
                                                                    currDays={timeDuration?.days ? Number(timeDuration?.days) : 0}
                                                                    currHour={timeDuration?.hours ? Number(timeDuration?.hours) : 0}
                                                                    currMin={timeDuration?.minutes ? Number(timeDuration?.minutes) : 0}
                                                                    isMultiParking={gateData?.facility?.is_multiday_parking != 0}
                                                                    setIsRateBandSelected={setIsRateBandSelected}
                                                                    setselctedDateTime={setselctedDateTime}
                                                                    selctedDateTime={selctedDateTime}
                                                                    rateBandData={rateBandData}
                                                                />}
                                                        </Row>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Row>
                                </Container>

                                <QRCodeComp
                                    paymentData={gateData}
                                    screen='extend'
                                />


                                {/* {/  section for Listing Data /} */}
                                {/* {listData?.length > 0 && <div className="d-block">
                                                <ListingDataComp loader={loader} listData={listData} />
                                            </div>} */}
                                {/* {(priceGreaterOrNot(gateData) && !loader) && <p className='text-primary my-2 fw-semibold py-1 ps-3 bg-primary bg-opacity-10' >Price Breakup</p>} */}
                                <div className="container pt-3 pb-5 overflow-hidden no-ticket-view">
                                    <div className={(!priceGreaterOrNot(gateData) && !loader) ? 'card shadow rounded-lg receiptCard no-view' : 'card shadow rounded-lg receiptCard'}>
                                        <PaymentBreakUpDetails
                                            breakDownTitle="Price Breakdown"
                                            loader={rateLoader}
                                            isSubmittingForm={false}
                                            className='py-2 d-flex'
                                            isDisplayDetails={true}
                                            paymentData={gateData}
                                            sectionKey={((gateData?.payable_amount != '0.00') && gateData?.payable_amount) ? '' : 'paymantResponse'}
                                            setIsDisplayDetails={setIsDisplayDetails}

                                        />
                                        <div className="card-footer">
                                            <AmountPaid
                                                className="pb-2 mb-2 d-flex justify-content-between"
                                                paymentData={gateData}
                                                paybleText="Amount to be Paid"
                                                sectionKey={(gateData?.payable_amount) ? '' : 'paymantResponse'}
                                                // isInfo
                                                // isExtendForm
                                                cardInside
                                                hideTaxIncluded={(gateData?.payable_amount > 0 && ((gateData?.tax_fee && gateData?.tax_fee != '0.00') || (gateData?.tax_rate && gateData?.tax_rate != '0.00'))) ? false : true}
                                                setIsDisplayDetails={setIsDisplayDetails}
                                                isTokenApiStarts={isTokenApiStarts}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {paymentReciept?.reservation?.ticketech_code && extend_data.is_extended === '0' ? <Form onSubmit={(e) => {
                                    e.preventDefault()
                                    onSubmit()
                                }}>

                                    {(loginData?.access_token) ? <>
                                        <Card className='m-2 paymentCardRadious p-2'>

                                            <span className='VehilceLables d-flex justify-content-between align-items-start'>Enter Payment Details <span onClick={handlePaymentModal}><i className='fa fa-plus small'></i> Add New Card</span></span>
                                            <ListGroup as="ol" onClick={() => handleCommonListModal()} className='mt-2'>
                                                <ListGroup.Item as="li" className="ps-1 d-flex justify-content-between align-items-start">
                                                    {/* <Image className='img-10' src={card_top_image} /> */}
                                                    <span style={{ height: '25px', width: '25px' }}>{getSvgIcon('Credit_card', 'var(--bs-primary)')}</span>
                                                    <div className="ms-2 me-auto text-secondary">Payment Method</div>
                                                    {(currentSelCard?.card_last_four) ? <div className='ms-2' style={{ marginTop: '-1px', marginRight: '3px' }}><Image src={getCardIcon(currentSelCard?.card_type)} style={{ height: '1.1rem', 'marginTop': '-0.2rem' }} /> <span className='text-primary fw-semibold me-1' >{currentSelCard?.card_last_four}</span></div> : <i className="fa fa-credit-card mr-2" style={{ marginRight: '0.5rem', marginTop: '4px' }} ></i>}
                                                    <i className='fa fa-caret-down mt-1' style={{ fontSize: '13px' }}></i>
                                                </ListGroup.Item>
                                            </ListGroup>

                                            {/* <Controller
                                                name='card_id'
                                                id='card_id'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field }) => <Form.Select aria-label="CardSelect" {...field}>
                                                    <option value=''>Please Select</option>
                                                    {cards?.map((item, index) => <option key={index} value={item?.card_holder_id}>{item?.card_last_four}</option>)}
                                                </Form.Select>}
                                            />
                                            {errors?.card_id?.type === 'required' && <Form.Text className="text-danger">This field is required</Form.Text>} */}

                                        </Card>
                                        {returnClockTimer()}
                                        <Row className='mb-4 m-auto w-100 justify-content-center'>
                                            {retunnValidateTicket()}

                                            <ExtendEndButton
                                                handleEndParking={handleConfimationModal}
                                                handleExtend={onSubmit}
                                                isExtendPrimary
                                                isTokenApiStarts={isTokenApiStarts}
                                                screen={'extend'}
                                                isFetching={loader}
                                            />
                                        </Row>
                                    </> :
                                        <PaymentGateDc faciltyData={facilityLocData} isSubmittingForm={isSubmittingForm} errors={errors} register={register} control={control} onSubmit={handleSubmit(onSubmit)} isTokenApiStarts={isTokenApiStarts} isInScreen setFocus={setFocus} extendBtn={true} returnClockTimer={returnClockTimer} retunnValidateTicket={retunnValidateTicket} />
                                    }
                                </Form> : <>
                                    {returnClockTimer()}
                                    <Row className='mb-2 justify-content-center'>
                                        {retunnValidateTicket()}
                                        <div className='col-sm-6'>
                                            <ExtendEndButton
                                                handleEndParking={handleConfimationModal}
                                                handleExtend={handleExtendSubmit}
                                                isExtendPrimary
                                                isTokenApiStarts={isTokenApiStarts}
                                                screen={'extend'}
                                                isFetching={loader}
                                                wideBtn={true}
                                                facilityData={gateData?.facility ? gateData?.facility : gateData}
                                            />
                                        </div>
                                    </Row>
                                </>}
                            </>
                        ) : null
                    : <NoData message={errorMessage?.invalidPartner} />}
            <ScrollCalendar isScrollCalendarModal={isScrollCalendarModal} setIsScrollCalendarModal={setIsScrollCalendarModal} setEntryDateTime={setEntryDateTime} extend={true} entryDateTime={local_checkout_datetime?.checkout_datetime ? local_checkout_datetime.checkout_datetime : gateData.checkout_datetime ? gateData.checkout_datetime : entryDateTime} handleEntryTime={handleEntryTime} setTotalLength={setTotalLength} isDateShow={true} setSeletedRateBand={setRateBandId} />
            <Footer />
            <PaymentBreakUpDetails
                loader={rateLoader}
                isSubmittingForm={false}
                className="py-2 "
                paymentData={gateData}
                sectionKey={((gateData?.payable_amount != '0.00') && gateData?.payable_amount) ? '' : 'paymantResponse'}
                isDisplayDetails={isDisplayDetails}
                setIsDisplayDetails={setIsDisplayDetails}
            />
            <PaymentModal isPaymentModalOpen={isPaymentModalOpen} setIsPaymentModalOpen={setIsPaymentModalOpen} notify={notify} isInScreen />
            <CommonListModal setCommonModal={setCommonModal} isCommonModalOpen={isCommonModalOpen} listData={cards} isThisVehicleModal={false} register={register} handleCurrentSelection={handleCurrentSelection} />
            {displayBanner ? <DownloadApp /> : null}
            <ConfirmationModal
                isConfimationModalOpen={isConfimationModalOpen}
                setIsConfimationModalOpen={setIsConfimationModalOpen}
                finalAction={handleEndParking}
            />
        </div>


    )
}

ExtendFormNew.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    notify: PropTypes.func,
    isFetchingPartner: PropTypes.bool,
    partnerDetails: PropTypes.object,
    cards: PropTypes.array
}

ExtendFormNew.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    notify: noop,
    isFetchingPartner: true,
    partnerDetails: EMPTY_OBJECT,
    cards: EMPTY_ARRAY,
}

function mapStateToProps({ login, transientReducer, userDetailsReducer, PaymentReducer }) {
    return {
        loader: login?.loader,
        isFetching: transientReducer?.isFetching,
        isFetchingPartner: userDetailsReducer?.isFetching,
        cards: PaymentReducer?.data?.data?.payments,
    }
}
export default connect(mapStateToProps)(ExtendFormNew)